import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import Title from '../../Components/Text/Title';
import MediaQuery, { useMediaQuery } from 'react-responsive'

import game_img1 from '../../Images/game_img1.png';
import game_img2 from '../../Images/game_img2.png';
import game_img3 from '../../Images/game_img3.png';
import game_img4 from '../../Images/game_img4.png';
import game_text_bg from '../../Images/game_text_bg.png';
import game_text_bg_m from '../../Images/game_text_bg_m.png';
import next_btn from '../../Images/next_btn.svg';
import prev_btn from '../../Images/prev_btn.svg';
import game_bg_img_top from '../../Images/game_bg_img_top.png';
import game_bg_img_bottom from '../../Images/game_bg_img_bottom.png';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding-top: 180px;
  padding-bottom: 390px;
  background-color: #080B31;
`
const SubContainer = styled.div`
  width: 970px;
  position: relative;
  @media (max-width: 1010px) {
    width: 320px;
  };
`
const CarouselContainer = styled.div`
  position: relative;
  margin-top: 80px;
  width: 100%;
  padding-left: 100px;
  z-index: 10;
  @media (max-width: 1010px) {
    padding-left: 0;
  };
`
const CarouselItemContainer = styled.div`
  display: flex;
  & > div + div{
    margin-left: 40px;
    @media (max-width: 460px) {
      margin-left: 0;
    };
  }
`
const CarouselItem = styled.div`
  position: relative; 
  display: flex;
  flex-shrink:0;
  width: 770px;
  height: 400px;
  border-radius: 20px;
  /* background-color: red; */
  overflow: hidden;
  /* transform: scale(0.95); */
  
  & > div:nth-child(1) {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 70%;
    & > img {
      margin-right: 20%;
      height: 100%;
    }
  }
  & > div:nth-child(2) {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 360px;
    & > img {
      position: relative;
      height: 100%;
      z-index: 0;
    }
    & > div {
      position: absolute;
      display: flex;
      flex-direction: column;
      height: 100%;
      top: 0px;
      left: 0px;
      padding-top: 50px;
      padding-left: 80px;
      padding-right: 40px;
      width: 100%;
      z-index: 10;
      & > h2 {
        color: white;
        font-size: 30px;
        margin-bottom: 20px;
      }
      & > p {
        /* margin-top: 5px; */
        color: white; 
        font-size: 13px;
        line-height: 200%;
        & > span {
          font-weight: 200;
        }
      }
      & > div {
        margin-top: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 50px;
        width: 230px;
        height: 40px;
        background-color: #FF8E00;
        cursor: pointer;
        & > p {
          color: white;
          font-size: 15px;
        }
      }
    }
  }
`
const MobileCarouselItem = styled.div`
  position: relative; 
  display: flex;
  flex-direction: column;
  flex-shrink:0;
  width: 320px;
  height: 640px;
  border-radius: 20px;
  overflow: hidden;
  & > div:nth-child(1) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 70%;
    & > img {
      height: 100%;
    }
  }
  & > div:nth-child(2) {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 380px;
    & > img {
      position: relative;
      width: 100%;
      z-index: 0;
    }
    & > div {
      position: absolute;
      display: flex;
      flex-direction: column;
      height: 100%;
      top: 0px;
      left: 0px;
      padding-top: 60px;
      padding-left: 30px;
      padding-right: 30px;
      width: 100%;
      z-index: 10;
      & > h2 {
        color: white;
        font-size: 30px;
        margin-bottom: 20px;
      }
      & > p {
        /* margin-top: 5px; */
        color: white; 
        font-size: 13px;
        line-height: 200%;
        & > span {
          font-weight: 200;
        }
      }
      & > div {
        margin-top: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 50px;
        width: 230px;
        height: 40px;
        background-color: #FF8E00;
        cursor: pointer;
        @media (max-width: 1010px) {
          width: 260px;
        };
        & > p {
          color: white;
          font-size: 15px;
        }
      }
    }
  }
`
const NextButton = styled.div`
  position: absolute;
  top: 250px;
  right: 50px;
  cursor: pointer;
  z-index: 100;
  & > img {
    width: 20px;
  }
  @media (max-width: 1010px) {
    right: -50px;
    top: 340px;
  };
  @media (max-width: 460px) {
    display: none;
  };
`
const PrevButton = styled.div`
  position: absolute;
  top: 250px;
  left: 50px;
  cursor: pointer;
  z-index: 100;
  & > img {
    width: 20px;
  }
  @media (max-width: 1010px) {
    left: -50px;
    top: 340px;
  };
  @media (max-width: 460px) {
    display: none;
  };
`
const TopBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 0;
  display: flex;
  justify-content: center;
  & > img {
    opacity: 0.3;
  }
`
const BottomBg = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 0;
  display: flex;
  justify-content: center;
  & > img {
    opacity: 0.3;
  }
`

const GamesContainer = ({ language }) => {
  const isBigScreen = useMediaQuery({ query: '(min-width: 1011px)' })
  const isMobileScreen = useMediaQuery({ query: '(min-width: 461px)' })

  const [mode, setMode] = useState('window');
  const [currentCarousel, setCurrentCarousel] = useState(1);
  const carouselRef = useRef(null);
  const carouselItemRef = useRef([]);
  const [startX, setStartX] = useState();
  const [moveX, setMoveX] = useState();
  const [gameItems, setGameItems] = useState([
    {
      img: game_img2,
      title: '영웅 맞고',
      gente: 'Card',
      developer: 'SNC games',
      palore: 'Mobile',
      store: '과금없이 즐길 수 있는 대한민국 오프라인 싱글 맞고 게임의 끝판왕이 등장했다!',
      url: 'https://play.google.com/store/apps/details?id=com.sncent.sncmatgo'
    },
    {
      img: game_img1,
      title: '환생 마스터',
      gente: 'RPG',
      developer: 'Tunup games',
      palore: 'Mobile',
      store: '자동으로 성장하는 완전 무료 방치형 게임!',
      url: 'https://play.google.com/store/apps/details?id=com.tunupgames.aos.rebirth'
    },
    {
      img: game_img3,
      title: '신영웅전설',
      gente: 'Role-playing',
      developer: ' Newhero games',
      palore: 'Mobile',
      store: '또 다시 혼돈에 휩싸인 선라이즈 대륙을 구하는 영웅이 되어 주세요',
      url: 'https://play.google.com/store/apps/details?id=com.legend.eternal&hl=ko&gl=US'
    },
    {
      img: game_img4,
      title: '공성타워디펜스',
      gente: 'Simulation',
      developer: 'piratesisland',
      palore: 'Mobile',
      store: '영웅을 다양한 구성으로 배치하고 성장시켜 적들을 물리치세요!',
      url: 'https://m.onestore.co.kr/mobilepoc/apps/appsDetail.omp?prodId=0000760291'
    }
  ])
  const [gameEngItems, setGameEngItems] = useState([
    {
      img: game_img2,
      title: 'Hit the Hero',
      gente: 'Card',
      developer: 'SNC games',
      palore: 'Mobile',
      store: 'The king of Korean offline single hit games that can be enjoyed without billing has appeared!',
      url: 'https://play.google.com/store/apps/details?id=com.sncent.sncmatgo'
    },
    {
      img: game_img1,
      title: 'Rebirth Master',
      gente: 'RPG',
      developer: 'Tunup games',
      palore: 'Mobile',
      store: 'A completely free idle game that grows automatically!',
      url: 'https://play.google.com/store/apps/details?id=com.tunupgames.aos.rebirth'
    },
    {
      img: game_img3,
      title: 'New Hero Legend',
      gente: 'Role-playing',
      developer: ' Newhero games',
      palore: 'Mobile',
      store: 'Be the hero to save the Sunrise Continent, which is again engulfed in chaos.',
      url: 'https://play.google.com/store/apps/details?id=com.legend.eternal&hl=ko&gl=US'
    },
    {
      img: game_img4,
      title: 'Siege Tower Defense',
      gente: 'Simulation',
      developer: 'piratesisland',
      palore: 'Mobile',
      store: 'Deploy and grow your heroes in various configurations to defeat your enemies!',
      url: 'https://m.onestore.co.kr/mobilepoc/apps/appsDetail.omp?prodId=0000760291'
    }
  ])

  const NextHandler = () => {
    if (currentCarousel >= gameItems.length - 1) {
      setCurrentCarousel(0);
      for (let i = 0; i < gameItems.length; i++) {
        carouselItemRef.current[i].style.opacity = 1;
        carouselItemRef.current[currentCarousel].style.transition = 'opacity 0.5s ease-in-out';
      }
    } else {
      carouselItemRef.current[currentCarousel].style.opacity = 0;
      carouselItemRef.current[currentCarousel].style.transition = 'opacity 0.5s ease-in-out';
      setCurrentCarousel(currentCarousel + 1)
    }
  };

  const PrevHandler = () => {
    if (currentCarousel === 0) {
      setCurrentCarousel(gameItems.length - 1);
      for (let i = 0; i < gameItems.length; i++) {
        if (i < gameItems.length - 1) {
          carouselItemRef.current[i].style.opacity = 0;
          carouselItemRef.current[currentCarousel].style.transition = 'opacity 1s ease-in-out';
        }
      }
    } else {
      carouselItemRef.current[currentCarousel - 1].style.opacity = 1;
      carouselItemRef.current[currentCarousel].style.transition = 'opacity 1s ease-in-out';
      setCurrentCarousel(currentCarousel - 1);
    }
  };

  useEffect(() => {
    if (isBigScreen) {
      setMode('window')
    } else {
      setMode('mobile')
    }
  })

  useEffect(() => {
    carouselRef.current.style.transition = 'all 0.5s ease-in-out';
    carouselRef.current.style.transform = `translateX(-${currentCarousel * (carouselItemRef.current[0].offsetWidth + (isMobileScreen ? 40 : 0))}px)`; // 백틱을 사용하여 슬라이드로 이동하는 에니메이션을 만듭니다.
    carouselItemRef.current[currentCarousel].style.transform = 'scale(1)';
    carouselItemRef.current[currentCarousel].style.opacity = '1';
    carouselItemRef.current[currentCarousel].style.opacity = 'all 0.5s ease-in-out';
    for (let i = 0; i < gameItems.length; i++) {
      if (i != currentCarousel) {
        carouselItemRef.current[i].style.transition = 'all 0.5s ease-in-out';
        carouselItemRef.current[i].style.transform = 'scale(0.85)';
        carouselItemRef.current[i].style.opacity = 0.4;
      }
    }
  }, [currentCarousel, gameItems.length, mode]);

  const onDragStart = (e) => {
    e.preventDefault();
    setStartX(e.changedTouches[0].pageX);
  };
  const onDragMove = (e) => {
    setMoveX(e.changedTouches[0].pageX);
  };
  const onDragEnd = (e) => {
    if (moveX - startX > 30) {
      PrevHandler()
    } else if (startX - moveX > 30) {
      NextHandler()
    }
  };
  const onMouseStart = (e) => {
    e.preventDefault();
    setStartX(e.pageX);
  };
  const onMouseMove = (e) => {
    setMoveX(e.pageX);
  };
  const onMouseEnd = (e) => {
    if (moveX - startX > 30) {
      PrevHandler()
    } else if (startX - moveX > 30) {
      NextHandler()
    }
  };

  return (
    <Container>
      <Title
        text={"GAMES"}
        color={"yellow"}
      />
      <SubContainer>
        <CarouselContainer
          ref={carouselRef}
          onMouseDown={onMouseStart}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseEnd}
          onTouchStart={onDragStart}
          onTouchMove={onDragMove}
          onTouchEnd={onDragEnd}
        >
          <CarouselItemContainer>
            {
              language === 'Korean' ?
              gameItems.map((item, index) => {
                return (
                  <>
                    <MediaQuery minWidth={1010}>
                      <CarouselItem
                        ref={ref => (carouselItemRef.current[index] = ref)}
                      >
                        <div>
                          <img alt="" src={item.img} />
                        </div>
                        <div>
                          <img alt="" src={game_text_bg} />
                          <div>
                            <h2>{item.title}</h2>
                            <p><span>GENRE :</span> {item.gente}</p>
                            <p><span>DEVELOPER :</span> {item.developer}</p>
                            <p><span>PLAFORM :</span> {item.palore}</p>
                            <p><span>STORE :</span> {item.store}</p>
                            <div
                              onClick={() => {
                                window.open(item.url);
                              }}
                            >
                              <p>VISIT STORE</p>
                            </div>
                          </div>
                        </div>
                      </CarouselItem>
                    </MediaQuery>
                    <MediaQuery maxWidth={1010}>
                      <MobileCarouselItem
                        ref={ref => (carouselItemRef.current[index] = ref)}
                      >
                        <div>
                          <img alt="" src={item.img} />
                        </div>
                        <div>
                          <img alt="" src={game_text_bg_m} />
                          <div>
                            <h2>{item.title}</h2>
                            <p><span>GENRE :</span> {item.gente}</p>
                            <p><span>DEVELOPER :</span> {item.developer}</p>
                            <p><span>PLAFORM :</span> {item.palore}</p>
                            <p><span>STORE :</span> {item.store}</p>
                            <div
                              onClick={() => {
                                window.open(item.url);
                              }}
                            >
                              <p>VISIT STORE</p>
                            </div>
                          </div>
                        </div>
                      </MobileCarouselItem>
                    </MediaQuery>
                  </>
                )
              })
              :
              gameEngItems.map((item, index) => {
                return (
                  <>
                    <MediaQuery minWidth={1010}>
                      <CarouselItem
                        ref={ref => (carouselItemRef.current[index] = ref)}
                      >
                        <div>
                          <img alt="" src={item.img} />
                        </div>
                        <div>
                          <img alt="" src={game_text_bg} />
                          <div>
                            <h2>{item.title}</h2>
                            <p><span>GENRE :</span> {item.gente}</p>
                            <p><span>DEVELOPER :</span> {item.developer}</p>
                            <p><span>PLAFORM :</span> {item.palore}</p>
                            <p><span>STORE :</span> {item.store}</p>
                            <div
                              onClick={() => {
                                window.open(item.url);
                              }}
                            >
                              <p>VISIT STORE</p>
                            </div>
                          </div>
                        </div>
                      </CarouselItem>
                    </MediaQuery>
                    <MediaQuery maxWidth={1010}>
                      <MobileCarouselItem
                        ref={ref => (carouselItemRef.current[index] = ref)}
                      >
                        <div>
                          <img alt="" src={item.img} />
                        </div>
                        <div>
                          <img alt="" src={game_text_bg_m} />
                          <div>
                            <h2>{item.title}</h2>
                            <p><span>GENRE :</span> {item.gente}</p>
                            <p><span>DEVELOPER :</span> {item.developer}</p>
                            <p><span>PLAFORM :</span> {item.palore}</p>
                            <p><span>STORE :</span> {item.store}</p>
                            <div
                              onClick={() => {
                                window.open(item.url);
                              }}
                            >
                              <p>VISIT STORE</p>
                            </div>
                          </div>
                        </div>
                      </MobileCarouselItem>
                    </MediaQuery>
                  </>
                )
              })
            }
          </CarouselItemContainer>
        </CarouselContainer>
        <PrevButton
          onClick={PrevHandler}
        >
          <img alt="" src={prev_btn} />
        </PrevButton>
        <NextButton
          onClick={NextHandler}
        >
          <img alt="" src={next_btn} />
        </NextButton>
      </SubContainer>
      <TopBg>
        <img alt="" src={game_bg_img_top} />
      </TopBg>
      <BottomBg>
        <img alt="" src={game_bg_img_bottom} />
      </BottomBg>
    </Container>
  )
}

export default GamesContainer;